<template>
	<div class="home">
		<header class="header">
			<div class="header__content">
				<div class="header__logo" @click="link(0)">
					<img src="@/assets/Genesis-Logo-Logo-Transparent.png" alt="Genesis Exhibits" />
				</div>
				<nav class="header__nav" :class="{'header__nav--open':menuOpen}">
					<i class="material-icons header__nav-button" @click="menuOpen = !menuOpen">menu</i>
					<a class="header__nav-item" href="https://www.exhibitsbygenesis.com">Main Site</a>
					<a class="header__nav-item" @click="link(1010); menuOpen = false">Virtual Exhibits</a>
					<a class="header__nav-item" @click="link(2350); menuOpen = false">Shared VR</a>
					<a class="header__nav-item" @click="link(3850); menuOpen = false">Shared AR</a>
					<a class="header__nav-item" @click="link(5000); menuOpen = false">Virtual Events</a>
					<a class="header__nav-item" @click="link(6400); menuOpen = false">Video Production</a>
					<a class="header__nav-item" @click="link(7600); menuOpen = false">Contact Us</a>
				</nav>
			</div>
			<linear-progress class="header__progress" :progress="loadProgress" :visible="loadProgress != 1" />
		</header>

		<div id="canvas_wrapper" class="panels">

			<div class="panel panel--1"
				data-0="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				data-300="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<h2
					data-0="transform: translateY(0%);"
					data-300="transform: translateY(-50%);"
					>
					We make your virtual content&hellip;<br /> "must-see VC"
				</h2>
				<p>Our virtual event designers can make your digital experience personal, powerful, memorable.</p>

				<explore class="scroll_indicator" />
			</div>

			<div class="panel panel--2"
				data-0="opacity: 0; pointer-events: none;"
				data-500="opacity: 0; transform: translateY(10%);"
				data-900="opacity: 1; transform: translateY(0%); pointer-events: any;"
				data-1200="opacity: 1; transform: translateY(0%);"
				data-1800="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<h2
					data-500="transform: translateY(20%)"
					data-900="transform: translateY(0%)"
					data-1200="transform: translateY(0%)"
					data-1800="transform: translateY(-50%)"
					>
					Virtual Exhibits
				</h2>
				<ul>
					<li>Visitors explore an immersive, digital twin of your exhibit or showroom.</li>
					<li>"Information Station" icons trigger text, graphics or video content.</li>
					<li>Content can be updated as needed.</li>
					<li>Browser-based delivery generates valuable metrics.</li>
				</ul>

				<!-- <p>Users can "walk-through" an immersive digital twin of your booth or showroom • The walkthrough can be created using renders of a 3d model or 360&deg; photos of a physical location  • Information Stations deliver text, graphics and video content • Browser-based delivery with metrics</p> -->
			</div>

			<div class="panel panel--3"
				data-0="opacity: 0; pointer-events: none;"
				data-1990="opacity: 0; transform: translateY(10%);"
				data-2290="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				data-2700="opacity: 1; transform: translateY(0%);"
				data-3300="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<h2
					data-1990="transform: translateY(20%)"
					data-2290="transform: translateY(0%)"
					data-2700="transform: translateY(0%)"
					data-3300="transform: translateY(-50%)"
					>
					Shared VR - A new sales reality
				</h2>
				<ul>
					<li>
						VIP Prospects receive a wireless VR headset, loaded with your custom VR experience.
					</li>
					<li>
						Using VR Chat, the prospect and your account exec tour the space simultaneously, interacting in real time even while distanced geographically.
					</li>
					<li>
						The shared journey creates a high-touch experience for high-value prospects.
					</li>
				</ul>
				<!-- <p>Wireless VR headsets, fully loaded with a 3d virtual version of your exhibit, showroom or factory, ship out to top VIP prospects and your assigned account execs • Using VR Chat, the prospect and the account exec tour the space simultaneously • The shared journey creates a personal, fully customized, high-touch experience for high-value prospects</p> -->
			</div>

			<div class="panel panel--4"
				data-0="opacity: 0; pointer-events: none;"
				data-3400="opacity: 0; transform: translateY(10%);"
				data-3700="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				data-4000="opacity: 1; transform: translateY(0%);"
				data-4400="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<h2
					data-3400="transform: translateY(20%);"
					data-3700="transform: translateY(0%);"
					data-4000="transform: translateY(0%);"
					data-4400="transform: translateY(-50%);"
					>
					Shared AR - A new sales reality
				</h2>

				<ul>
					<li>An AR app lets prospects see &hellip;in 360&deg;&hellip; how your equipment fits into their facility.</li>
					<li>Using Collaborative Sessions, the prospect and your engineers navigate the experience simultaneously, interacting in real time even while distanced geographically.</li>
					<li>Prospects "try your solution on for size" to see what a future partnership looks like.</li>
				</ul>
			</div>

			<div class="panel panel--5"
				data-0="opacity: 0; pointer-events: none;"
				data-4700="opacity: 0; transform: translateY(10%);"
				data-4900="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				data-5300="opacity: 1; transform: translateY(0%);"
				data-5600="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<h2
					data-4700="transform: translateY(20%);"
					data-4900="transform: translateY(0%);"
					data-5300="transform: translateY(0%);"
					data-5600="transform: translateY(-50%);"
					>
					Virtual Meetings, Conferences &amp; Tradeshows
				</h2>

				<p>Our virtual event designers make online experiences personal, powerful, and memorable. </p>
				<ul class="column column--3">
					<li>Strategic Planning</li>
					<li>Session Design</li>
					<li>Training</li>
					<li>Technology Selection</li>
					<li>Attendee Interaction</li>
					<li>Project Management</li>
					<li>Experience Architecture</li>
					<li>Content Development</li>
					<li>Evaluation & Metrics</li>
				</ul>

				<!-- <p>Our virtual event designers can make your online experience personal, powerful, memorable • Strategic planning · Technology and platform selection · Experience design · Attendee engagement · Content development and production · Education management · Facilitator training · Project management · Evaluation and metrics</p> -->
			</div>

			<div class="panel panel--6"
				data-0="opacity: 0; pointer-events: none;"
				data-6100="opacity: 0; transform: translateY(10%);"
				data-6350="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				data-6700="opacity: 1; transform: translateY(0%);"
				data-6900="opacity: 0; transform: translateY(-10%); pointer-events: none;"
				>
				<p><iframe
					data-6100="opacity: 0;"
					data-6350="opacity: 1;"
					width="700"
					height="394"
					src="https://www.youtube-nocookie.com/embed/lW_xVuB67E0?rel=0"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
					class="video-embed"
				></iframe></p>

				<h2
					data-6100="transform: translateY(30%);"
					data-6350="transform: translateY(0%);"
					data-6700="transform: translateY(0%);"
					data-6900="transform: translateY(-50%);"
					>
					Video Production
				</h2>
				<p>When you can't be face-to-face, nothing tells your story like a well-written and well-produced video. </p>
			</div>

			<div class="panel panel--7"
				data-0="opacity: 0;"
				data-7200="opacity: 0; transform: translateY(10%); pointer-events: none;"
				data-7400="opacity: 1; transform: translateY(0%); pointer-events: auto;"
				>
				<h2>
					Genesis Exhibits<br />
					New York | San Francisco
				</h2>
				<h4>
					<a href="https://www.exhibitsbygenesis.com/ContactUs.aspx">CONTACT US</a>
				</h4>


				<!-- <p><iframe src="//getsynchronicity.com/gfembed/?f=3" width="100%" height="600" frameBorder="0" class="gfiframe"></iframe></p> -->
			</div>
		</div>

		<canvas></canvas>

	</div>
</template>

<script>
// @ is an alias to /src
import { smoothScroll } from '@/lib/utils'
import pf from 'smoothscroll-polyfill'

import Explore from '@/components/Explore'
import LinearProgress from '@/components/LinearProgress'

export default {
	name: 'Home',
	components: {
		Explore,
		LinearProgress,
	},
	data: () => ({
		context: null,
		sequence: [],
		frameCount: 778,
		frameGap: 10,
		frameSize:{
			width: 1280,
			height: 900,
		},
		imageSize: {
			width: 1280,
			height: 900,
		},
		frame: 0,
		menuOpen: false,
		canvas: null,
		wrapper: null,
		loadProgress: 0,
	}),
	created() {
		window.addEventListener('smoothScroll', this.sequencer)
		window.addEventListener('resize', this.sizer)
	},
	destroyed() {
		window.removeEventListener('smoothscroll', this.sequencer)
		window.removeEventListener('resize', this.sizer)
	},
	mounted() {
		pf.polyfill()
		this.canvas = document.querySelector('canvas')
		this.wrapper = document.querySelector('#canvas_wrapper')
		this.sizer()
		this.preloader()

		let embedScript = document.createElement('script')
		embedScript.setAttribute('src', '//getsynchronicity.com/wp-content/plugins/gravity-forms-iframe-master/assets/scripts/gfembed.min.js')
		document.body.appendChild(embedScript)
	},
	methods: {
		sizer() {
			// const canvas = document.querySelector('canvas')
			// const wrapper = document.querySelector('#canvas_wrapper')
			this.canvas.height = window.innerHeight
			this.canvas.width = Math.min(window.innerWidth, document.body.clientWidth)
console.log(window.innerWidth, document.body.clientWidth, this.canvas.width)
			this.context = this.canvas.getContext('2d')

			const imgRatio = this.frameSize.height / this.frameSize.width
			const canvasRatio = this.canvas.height / this.canvas.width

			if (imgRatio > canvasRatio) {
				const h = this.canvas.width * imgRatio
				this.imageSize = {
					width: this.canvas.width,
					height: h,
					y: (this.canvas.height - h) / 2,
					x: 0,
				}
			} else {
				const w = this.canvas.width * canvasRatio / imgRatio
				this.imageSize = {
					width: w,
					height: this.canvas.height,
					x: (this.canvas.width - w) / 2,
					y: 0,
				}
			}

			this.wrapper.style.height = (document.body.clientHeight + (this.frameCount * this.frameGap))+'px'
		},
		preloader() {
			let loadCount = 0
			for (var i = 0; i <= this.frameCount; i++) {
				let img = new Image()
				let imgPath = `sequence/VirtualCapabilities_${String(i).padStart(5,0)}.jpg`
				img.src = require(`@/assets/${imgPath}`)
				this.sequence.push(img)

				if (i === 0) {
					img.onload = () => {
						this.context.drawImage(img, this.imageSize.x, this.imageSize.y, this.imageSize.width, this.imageSize.height)
					}
				} else {
					img.onload = () => {
						loadCount++
						this.loadProgress = Math.min(1, Math.max(0, (loadCount / this.frameCount)))
					}
				}
			}
		},
		sequencer(evt) {
			const frame = Math.min(this.frameCount, Math.round(Math.abs(evt.detail.bounds.top / this.frameGap)))
			// this.frame = `${frame} - ${evt.detail.bounds.top}`
			this.context.drawImage(this.sequence[frame], this.imageSize.x, this.imageSize.y, this.imageSize.width, this.imageSize.height)
		},
		link(top) {
			window.scroll({
				top,
				left: 0,
				behavior: 'smooth',
			})
		},
	},
	metaInfo: () => ({
		script: [
			{
				src: '//getsynchronicity.com/wp-content/plugins/gravity-forms-iframe-master/assets/scripts/gfembed.min.js',
				type: 'text/javascript',
			},
		],
	}),
}
</script>

<style lang="scss" scoped>

@mixin media-query($size: 800px) {
	@media screen and (max-width: $size) {
		@content;
	}
}

.home {
	background-color: black;
}

canvas {
	bottom: 0;
	left: 0;
	position:fixed;
	right: 0;
	top: 0;
	z-index: 2;
}

.header {
	background-color: rgba(0, 0, 0, 0.75);
	backdrop-filter: saturate(150%) blur(20px);
	display: flex;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 20;

	&__content {
		display: flex;
		flex-direction: column;
		max-width: 1000px;
		padding-left: 1rem;
		padding-right: 1rem;
		width: 100%;

		@include media-query() {
			flex-direction: row;
			justify-content: space-between;
		}
	}

	&__nav {
		align-items: center;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 14px;
		width: 100%;
		padding-bottom: 1rem;

		@include media-query() {
			align-items: flex-end;
			flex-direction: column;
			padding: 1rem;
			padding-bottom: 0;
			// position: absolute;
			// right: 1rem;
			// top: 1rem;
			width: auto;
			z-index: 20;

			&--open {
				padding-bottom: 1rem;
			}
		}

		&-button {
			color: white;
			display: none;
			user-select: none;

			@include media-query() {
				display: block;
			}
		}

		&-item {
			color: #93c7df;
			cursor: pointer;
			text-decoration: none;
			text-transform: uppercase;
			transition: color 150ms linear;

			&:hover {
				color: #a7dcf5;
			}

			@include media-query() {
				display: none;
				padding-bottom: 0.5rem;
				padding-top: 0.5rem;

				.header__nav--open & {
					display: block;
				}
			}
		}
	}

	&__logo {
		padding: 1rem;
		padding-left: 0;

		@include media-query() {
			padding-left: 1rem;
		}

		img {
			max-width: 170px;
		}
	}

	&__progress {
		bottom: 0;
		left: 0;
		position: absolute;
	}
}

.panels {
	background-color: rgba(0, 0, 0, 0.4);
	display: flex;
	justify-content: center;
	position: relative;
	width: 100%;
	z-index: 5;

	@include media-query() {
		flex-direction: column;
		justify-content: space-between;
	}

	.scroll_indicator {
		align-self: center;
		margin-top: 2rem;
	}
}

.panel {
	// align-items: center;
	justify-content: center;
	color: white;
	display: flex;
	flex-direction: column;
	font-size: 30px;
	max-width: 1000px;
	min-height: 100vh;
	opacity: 0;
	overflow-x: hidden;
	position: fixed;
	// width: 100%;
	padding: 1rem;
	width: calc(100% - 2rem);
	z-index: 10;

	@include media-query() {
		opacity: 1;
		position: relative;
	}

	&--1 {
		opacity: 1;
	}

	h2 {
		font-size: 38px;
		font-weight: 800;
		margin-bottom: 0.5em;
		text-shadow: 0 2px 4px rgba(0,0,0,.4);

		@include media-query() {
			font-size: 28px;
		}
	}

	h5 {
		opacity: 0.85;
	}

	a {
		color: #93c7df;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	p,
	ul {
		font-size: 22px;
		margin-top: 0;
		padding: 0;
		text-shadow: 0 1px 3px rgba(0,0,0,.4);

		@include media-query() {
			font-size: 18px;
		}
	}

	ul {
		padding-left: 2rem;

		&.column {
			column-count: 3;

			@include media-query() {
				column-count: 2;
				padding-left: 1rem;
				padding-right: 0;
			}
		}

		li {
			margin-bottom: 1rem;
		}
	}

	.video-embed {
		margin-left: 50%;
		transform: translateX(-50%);
		max-width: 80%;
	}

	iframe {
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 0.5rem;
		max-width: 500px;
		padding: 1rem;
		width: calc(100% - 2rem);
	}
}

.frame-counter {
	color: white;
	position: fixed;
	right: 0;
	bottom: 0;
	z-index: 4;
}
</style>
